<template>
	<div class="mb-2">
		<div
			v-if="!isMobile"
			class="panel info-panel columns "
			:style="`width: calc(100% - ${menuWidth}px)`"
		>
			<!-- <div class="edge-left" /> -->
			<div v-if="!noSearch" class="top-column dropdown ">
				<div class="panel-block">
					<!-- <p class="label">Sök</p> -->
					<SearchBar @search="search" :placeholder="units[0]" />
				</div>
			</div>
			<div v-if="orderBys" class="arrow top-column sort-icon is-flex is-justify-content-flex-end is-align-items-center">
				<i class="fas" :class="ascDesc" @click="toggleDescending"></i>
			</div>
			<div class="top-column dropdown" v-if="orderBys">
				<div class="panel-block  pl-1">
					<!-- <p class="label">Sortera på</p> -->
					<CustomSelect
						:value="localOrderBy"
						:options="orderBys"
						:placeholder="$t('toppanel.sortBy')"
						:trackBy="'name'"
						@select="doOrderBy"
					/>
				</div>
			</div>
			<div class="top-column dropdown" v-if="showBuildings">
				<div class="panel-block">
					<!-- <p class="label">Kund</p> -->
					<CustomSelect
						:value="getSelectedBuilding"
						:options="getBuildings"
						:placeholder="$t('toppanel.selectBuilding')"
						@select="setBuilding"
						@search="searchBuildings"
						:show-load-more="buildingsHasMore"
						@on-load-more="loadMoreBuildings"
						:loading="dropdownIsLoading"
					/>
				</div>
			</div>

			<div v-if="pagination" class="info-column">
				<div class="panel-block">
					<!-- <p class="label">Info</p> -->
					<div class="box">
						{{ pagination.totalCount }}: {{ units[1] }}
					</div>
				</div>
			</div>
			<div class="top-column" v-if="!hideAdd">
				<div class="panel-block" :class="disableNew ? 'tooltip' : ''">
					<button
						class="button is-small is-info extra"
						:disabled="disableNew"
						@click.stop="toggleAdd"
					>
						<span class="icon"><i class="fas fa-plus"/></span
						><span>{{ units[2] }}</span>
					</button>
					<span
						v-if="disableNew" class="tooltip-text"
					>{{ $t('toppanel.selectCustomerToCreate') }}</span
					>
				</div>
			</div>
			<!-- <div class="edge-right" /> -->
			<slot></slot>
		</div>
		<div v-else class="panel info-panel columns is-mobile mobile">
			<div v-if="!noSearch" class="top-column">
				<div class="panel-block">
					<!-- <p class="label">Sök</p> -->
					<SearchBar @search="search" :placeholder="units[0]" />
				</div>
			</div>
			<div class="panel-block mobile" v-if="!hideAdd">
				<button
					class="button is-small is-dark"
					:disabled="disableNew"
					@click.stop="toggleAdd"
				>
					<span class="icon is-info"><i class="fas fa-plus"/></span>
				</button>
			</div>
			<slot></slot>
		</div>
	</div>
</template>

<script>
import CustomSelect from '@/components/CustomSelect';
import SearchBar from '@/components/SearchBar';
import { mapActions, mapGetters } from 'vuex';

export default {
	components: {
		CustomSelect,
		SearchBar
	},
	props: {
		units: {
			type: Array,
			required: false
		},
		pagination: {
			type: Object,
			required: false
		},
		orderBys: Array,
		showBuildings: {
			type: Boolean,
			default: false
		},
		customerOverride: Boolean,
		orderBy: {
			type: String,
			default: ''
		},
		noSearch: Boolean,
		hideAdd: {
			type: Boolean,
			default: true
		}
	},

	data: () => ({
		buildings: [],
		buildingsHasMore: true,
		buildingsPage: 1,
		buildingSearchQuery: '',
		descending: false,
		dropdownIsLoading: false,
		localOrderBy: null 
	}),

	computed: {
		...mapGetters('appStore', ['isMobile', 'isCollapsed']),
		...mapGetters('user', [
			'getUser',
			'getActiveCompany',
			'getActiveCustomer'
		]),
		...mapGetters('buildingStore', ['selectedBuilding', 'getUserBuildingId']),

		ascDesc() {
			return this.orderBy.includes('desc') ? 'fa-arrow-down' : 'fa-arrow-up';
		},

		getSelectedBuilding() {
			if(!this.selectedBuilding.id && this.getUserBuildingId !== null) {
				return {
					id: '__userBuildingId__',
					name: this.$t ? this.$t('toppanel.myBuildings') : 'Mina byggnader'
				};
			}

			if(!this.selectedBuilding.id) {
				return {
					id: null,
					name: this.$t ? this.$t('toppanel.allBuildings') : 'Alla byggnader'
				};
			}

			return this.selectedBuilding;
		},

		getBuildings() {
			return [this.$isAllowedTo('top_panel_fetch_buildings_without_user_id') && {
				id: null,
				name: this.$t ? this.$t('toppanel.allBuildings') : 'Alla byggnader'
			}, {
				id: '__userBuildingId__',
				name: this.$t ? this.$t('toppanel.myBuildings') : 'Mina byggnader'
			},
			...this.buildings].filter(Boolean);
		},

		disableNew() {
			if (this.customerOverride) {
				return false;
			} else {
				return this.comShowCustomer && !this.getActiveCustomer?.id;
			}
		},

		menuWidth() {
			return this.isCollapsed ? 200 : 350;
		}
	},

	watch: {
		async 'getActiveCustomer.id'() {
			if (!this.showBuildings) {
				return;
			}

			this.buildings = [];
			this.buildingsPage = 1;
			this.buildingSearchQuery = '';
			await this.fetchBuildings();

			this.setSelectedBuilding({
				id: null,
				name: this.$t ? this.$t('toppanel.allBuildings') : 'Alla byggnader'
			});
		}
	},

	created() {
		if (this.showBuildings) {
			this.fetchBuildings();
		}

		if (this.orderBys) {
			const getOrderBy = element => element.value == this.orderBy.split(' ')[0];
			this.descending = this.orderBy.split(' ')[1] == 'desc';
			let index = this.orderBys.findIndex(getOrderBy);
			this.localOrderBy = this.orderBys[index];
		}
	},

	methods: {
		...mapActions('buildingStore', ['setSelectedBuilding','setUserBuildingId']),

		onBuildingSelect(building) {
			this.$emit('on-building-select', building);
		},

		onBuildingSearch(searchQuery) {
			this.$emit('on-building-search', searchQuery);
		},

		setBuilding(building) {
			if(building.id === '__userBuildingId__') {
				this.setSelectedBuilding({
					id: null
				});
				this.setUserBuildingId(this.getUser.id);

				return;
			}

			this.setUserBuildingId(null);
			this.setSelectedBuilding(building);
		},

		searchBuildings(search) {
			this.buildingSearchQuery = search;
			this.buildings = [];
			this.buildingsPage = 1;
			this.fetchBuildings();
		},

		toggleAdd() {
			this.$emit('toggleAdd');
		},

		search(searchValue) {
			this.$emit('search', searchValue);
		},

		toggleDescending() {
			if (this.descending) {
				this.$emit('orderBy', this.localOrderBy.value);
				this.descending = false;
			} else {
				this.$emit('orderBy', this.localOrderBy.value + ' desc');
				this.descending = true;
			}
		},

		doOrderBy(orderBy) {
			this.localOrderBy = orderBy;
			this.$emit('orderBy', orderBy.value);
		},

		loadMoreBuildings() {
			this.buildingsPage = this.buildingsPage + 1;
			this.fetchBuildings();
		},

		async fetchBuildings() {
			try {
				const data = await this.$services.building.list({
					pageNumber: this.buildingsPage,
					customerId: this.getActiveCustomer?.id,
					userId: this.$isAllowedTo('top_panel_fetch_buildings_without_user_id') ? null : this.getUser.id,
					name: this.buildingSearchQuery
				}, {
					loading: val => {
						this.dropdownIsLoading = val;
					}
				});

				this.buildingsHasMore = data._pagination.currentPage < data._pagination.totalPages;

				this.buildings = [
					...this.buildings,
					...data
				];
			} catch (error) {
				console.log(error);
			}
		}
	}
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";
@import "@/assets/colors.scss";

.panel.info-panel {
  position: absolute;
  pointer-events: none;
  margin-left: -8px;
  top: $navbar-height + 0.75rem;
  background-color: transparent;
  width: calc(100% - 300px);
  color: $white;
  border-radius: 0;
  z-index: 1;
  &.mobile {
    z-index: 4;
    position: fixed;
  }
}
.panel.info-panel.narrow {
  width: 100%;
}
.info-panel .column {
  max-width: 172px;
  padding: 0;
}
.block .label {
  margin-bottom: 2px;
  margin-left: -5px;
  font-size: 10px;
  z-index: 10;
}
.panel-block {
  position: relative;
  padding-top: 7px;
  width: 100%;
  .label {
    position: absolute;
    // top: -10px;
    left: 5px;
    z-index: 8;
    font-size: 10px;
  }
  .button {
    z-index: 2;
  }
}
.panel-block:only-child {
  margin-top: 0;
}
.edge-right {
  position: absolute;
  transform: skew(-30deg);
  right: -20px;
  background-color: transparent;
  width: 40px;
  height: 100%;
}
.edge-left {
  position: absolute;
  transform: skew(30deg);
  left: -20px;
  background-color: $light;
  width: 40px;
  height: 100%;
}
.panel-block .box {
  background-color: #f5f5f5;
  color: $dark;
  font-size: 12px;
  width: 100%;
  padding: 6px 10px;
  border: 1px solid #acacac;
  box-shadow: none;
}
.top-column {
  width: 100%;
  max-width: 172px;
  background: #ffffffe5;
  // box-shadow: 5px 5px 10px #ffffffe5;
  pointer-events: all;
  &.dropdown {
    min-width: 172px;
  }
  &.top-column.arrow {
    i {
		pointer-events: auto;
		margin-top: 0 !important;
      cursor: pointer;
    }
    i:hover {
      color: $info;
    }
  }
}

.sort-icon {
	width: 30px;

}
.panel.info-panel.mobile {
  margin-top: -12px;
  margin-left: -8px;
  width: 100vw;
}
.panel-block.mobile {
  margin-left: auto;
  margin-right: 0.3rem;
  width: 53px;
  background: #ffffffe5;
  box-shadow: -5px 5px 10px #ffffffe5;
  pointer-events: all;
}
.column.filler {
  max-width: 40px;
}
.info-column {
  background: #ffffffe5;
  // box-shadow: 5px 5px 10px #ffffffe5;
  min-width: 172px;
  max-width: 172px;
  pointer-events: all;
}
</style>
